<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-card-item class="text-h6">Search Records</v-card-item>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field label="First Name" prepend-icon="mdi-magnify" v-model="search.firstname" @update:modelValue="searchTimeout();"/>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field label="Last Name" prepend-icon="mdi-magnify" v-model="search.lastname" @update:modelValue="searchTimeout();"/>
      </v-col>
      <v-col cols="12" md="6">
        <v-switch color="primary" v-model="search.deceased" :label="search.deceased ? 'Deceased Only' : 'All Records'" @change="searchTimeout()" />
      </v-col>
      <v-col cols="12" align="right">
        <v-btn text="Search" />
      </v-col>
    </v-row>
    <v-container fluid v-if="loading">
      <v-row>
        <v-col>
          <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid v-if="people.length > 0">
      <v-row v-for="person in people.slice((currentpage-1)*5, (currentpage-1)*5+5)" :key="person.id">
        <v-col>
          <PersonDialog :cemeteries="cemeteries" :person="person" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-pagination v-model="currentpage" :length="pages" />
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid v-else>
      <v-row>
        <v-col>
          <v-card-item>Showing 0 records - Search our community records by typing a name above</v-card-item>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import PersonDialog from './PersonDialog.vue';


export default {
  name: 'SearchComponent',

  components:{
    PersonDialog
  },

  props:{
    cemeteryid : Number
  },

  data: () => ({
    search : {
      firstname : "",
      lastname : "",
      cemeteryid : null,
      deceased : true
    },
    people : [],
    cemeteries : [],
    pages : 0,
    currentpage : 1,
    loading : false,
  }),

  created : function(){
    this.search.cemeteryid = this.cemeteryid;
  },

  methods: {
    searchTimeout(){
      clearTimeout(this.searchtimeout);
      this.searchtimeout = setTimeout(()=>{
        this.reloadView()
      }, 500);
    },
    reloadView(){
      this.people = [];
      this.pages = 0;
      this.currentpage = 1;
      this.loading = false;

      if(this.search.firstname == "" && this.search.lastname == "") return;

      this.loading = true;

      fetch("https://app.cemeterycommunity.com:11000/api/getcemeterieswithgenealogystatus", { method: "POST" })
      .then( res => res.json() )
      .then( res =>  {
        if(res.results == "Failed" ) return;
        else if(res.results == "Failed - Auth") return;
        else this.cemeteries = res.results;
      });
      fetch("https://app.cemeterycommunity.com:11000/api/g-searchpeoplebyname", { method: "POST", headers : { data : JSON.stringify(this.search) } })
      .then( res => res.json() )
      .then( res =>  {
        if(res.results == "Failed" ) return;
        else if(res.results == "Failed - Auth") return;
        else this.people = res.results;

        this.loading = false;

        this.pages = Math.floor(this.people.length / 5);
      });
    },
  }
}
</script>